import { render, staticRenderFns } from "./FullText.vue?vue&type=template&id=1e5c1e49"
import script from "./FullText.vue?vue&type=script&lang=js"
export * from "./FullText.vue?vue&type=script&lang=js"
import style0 from "./FullText.vue?vue&type=style&index=0&id=1e5c1e49&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports